import { gql, useQuery } from '@apollo/client';

import { ALL_QUESTION_FIELDS } from '../fragments/question.fragments';

import { Question, QuestionsData } from '../types/kb';
import { useSpecialty, useVersion } from './useVersion';

const GET_QUESTION_QUERY = gql`
  ${ALL_QUESTION_FIELDS}
  query Question($version: Float!, $specialty: String, $extId: String!) {
    questions(
      where: {
        version: { eq: $version }
        specialty: { eq: $specialty }
        extId: { eq: $extId }
      }
    ) {
      ...AllQuestionFields
    }
  }
`;

export const useQuestion = (extId: Question['extId'] | null) => {
  const version = useVersion();
  const specialty = useSpecialty();

  return useQuery<QuestionsData>(GET_QUESTION_QUERY, {
    variables: { version, specialty, extId: extId },
  });
};
